import script from "./ContentBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentBox.vue?vue&type=script&lang=ts&setup=true"

import "./ContentBox.vue?vue&type=style&index=0&id=6e471a4e&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e471a4e"]])

export default __exports__